import React, { Component } from 'react';
import { connect } from 'react-redux';

import PollResults from 'components/shared/PollResults';
import SurveyForm from '../SurveyForm';

import { localize } from 'react-localize-redux';

import { cancelLeaseTermination } from 'actions/landlordTenantsActions';
import { getTenancyStatus } from 'actions/dashboardActions';
import { submitSurvey } from 'actions/surveyActions';
import { showSuccess } from 'actions/notificationActions';

import { AccentColor } from 'helpers/AccentColorHelper';

import { CSSTransitionGroup } from 'react-transition-group';

export default localize()(
  connect(
    store => ({
      pollDetails: store.dashboard.pollDetails,
      hasPoll: store.dashboard.hasPoll,
    }),
    { cancelLeaseTermination, getTenancyStatus, submitSurvey, showSuccess }
  )(
    class PollDashboard extends Component {
      constructor(props) {
        super(props);
        this.state = {
          questionResponses: null,
        };
      }

      handleSubmit = values => {
        let questionResponses = this.props.pollDetails.poll_results[0].question_responses;
        let answerSelected = questionResponses[Number(values.questions[0].answer)].response_count;
        questionResponses[Number(values.questions[0].answer)]['response_count'] =
          answerSelected + 1;

        return this.props
          .submitSurvey(this.props.pollDetails.uuid, this.props.pollDetails.access_token, values)
          .then(() => {
            this.setState({ questionResponses });
            this.props.showSuccess('pollResponseSuccessfullySubmitted');
          });
      };

      render() {
        if (!this.props.hasPoll) return null;
        return (
          <div className="row">
            <h3 style={{ margin: '15px 0' }}>
              {this.props.translate('poll')}
              <b style={{ fontFamily: 'Circular-Black', color: AccentColor() }}>.</b>
            </h3>
            <h4 style={{ marginBottom: '-10px' }}> {this.props.pollDetails.poll_description} </h4>
            <CSSTransitionGroup
              transitionName="fade_out_buttons"
              transitionEnterTimeout={200}
              transitionLeaveTimeout={200}
            >
              <div className="row" style={{ width: '85%', maxWidth: '350px', textAlign: 'center' }}>
                {this.renderSurveyForm()}
                {this.renderSurveyQuestions()}
              </div>
            </CSSTransitionGroup>
          </div>
        );
      }

      renderSurveyForm = () => {
        if (this.state.questionResponses) return;

        return (
          <SurveyForm
            onSubmit={this.handleSubmit}
            surveyQuestions={this.props.pollDetails.poll_questions}
            pollResults={this.props.pollDetails.poll_results}
          />
        );
      };

      renderSurveyQuestions = () => {
        if (!this.state.questionResponses) return;

        return (
          <div style={{ marginTop: '40px' }}>
            <PollResults results={this.state.questionResponses} />
          </div>
        );
      };
    }
  )
);
